import { Component, Inject, LOCALE_ID, ViewChild, ElementRef, AfterViewInit, AfterContentInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Account, AccountResource, Address, DetailedAddress, Organization, OrganizationResource, WorkDay, WorkSchedule, WorkScheduleAddressSource, WorkScheduleExemption, WorkScheduleResource } from '@apaq/orgkit-js';
import { container } from 'tsyringe';
import { PageRequest } from '@apaq/leap-data-core';
import { AbsenceDatasource } from './absence-datasource';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ContextService } from 'ngx-orgkit';

const ORGANIZATION = 'Organization';
const ACCOUNT = 'Account';
const CUSTOM = 'Custom';

@Component({
  selector: 'app-resource-editor-view',
  templateUrl: './resource-editor-view.component.html',
  styleUrls: ['./resource-editor-view.component.scss']
})
export class ResourceEditorComponent implements AfterContentInit {

  @ViewChild('absence') absenceCalendar?: ElementRef;

  account?: Account;
  workSchedule?: WorkSchedule;
  mode = 'month';
  innerDate?: Date;
  modalVisible = false;
  addressModalVisible = false;
  periodStart?: Date;
  periodEnd?: Date;
  selectedTab = 0;
  organization?: Organization;
  adjustedAddress?: DetailedAddress;
  _addressMode?: string | null;
  absenceDatasource?: AbsenceDatasource;
  form: FormGroup;
  initialized = false;
  constructor(private activeRoute: ActivatedRoute,
    private contextService: ContextService,
    private router: Router,
    @Inject(LOCALE_ID) public locale: string,
    private fb: FormBuilder,
    private workscheduleResource: WorkScheduleResource,
    private accountResource: AccountResource,
    private organizationResource: OrganizationResource) {


    this.form = fb.group({
      'id': fb.control(null),
      'accountId': fb.control(null),
      'location': fb.control(null),
      'address': fb.control(null),
      'monday': fb.control(null),
      'tuesday': fb.control(null),
      'wednesday': fb.control(null),
      'thursday': fb.control(null),
      'friday': fb.control(null),
      'saturday': fb.control(null),
      'sunday': fb.control(null),
      'offOnPublicHolidays': fb.control(false),
      'exemptions': fb.control([]),
      'commission': fb.control(0),
      'addressSource': fb.control(null)
    });

    this.form.get('addressSource')?.valueChanges.subscribe((value: WorkScheduleAddressSource) => {
      if (value === 'WorkSchedule') {
        this.form.get('address')?.enable();
      } else {
        this.form.get('address')?.disable();
      }
    });
  }


  async ngAfterContentInit() {
    const id = this.activeRoute.snapshot.params.id;
    this.account = await this.accountResource.findById(id);

    const result = await this.workscheduleResource.findAll({ query: { accountId: this.account.id } } as PageRequest);
    if (result.content.length > 0) {
      this.workSchedule = result.content[0];
      this.form.patchValue(this.workSchedule);
    }

    this.organization = await this.organizationResource.findById(this.contextService.organizationId!);
    this.initialized = true;
  }

  back() {
    this.router.navigate(['people']);
  }

  get commission() {
    return Math.round((this.form.get('commission')?.value ?? 0) * 100);
  }

  set commission(value: number) {
    this.form.get('commission')?.setValue(value / 100);
    this.form.markAsDirty();
  }

  public save() {
    this.workscheduleResource.save(this.form.value).then(result => {
      this.router.navigate(['people']);
    });
  }


}
